/**
 * location.hash格式化为对象
 */
var getHashObject = function () {
  if (!location.hash) return {};
  var arrHash = location.hash.slice(1).split('&');
  return arrHash.reduce(function (obj, it) {
    const key = it.split('=')[0];
    const value = it.split('=')[1];
    obj[key] = value;
    return obj;
  }, {});
};

/**
 * 获取location.hash中某字段的值 路由hash模式慎用
 * @param {String} key 要获取的字段的key值
 * @returns {String} value
 */
var get = function(key) {
  var value = getHashObject()[key]
  return value && decodeURIComponent(value);
};

/**
 * location.hash增加某字段 路由hash模式慎用
 * @param {String} key 要增加的key值
 * @param {String|Number} value 要增加的value值
 * @returns {String} location.hash
 */
var add = function (key, value) {
  var oldHashObj = getHashObject();
  var newHashObj = {}
  Object.keys(oldHashObj).forEach(function(key) {
    newHashObj[key] = oldHashObj[key]
  });
  newHashObj[key] = encodeURIComponent(value);
  var newHash = Object.keys(newHashObj).map(function(key) {
    return `${key}=${newHashObj[key]}`
  }).join('&')
  return `#${newHash}`
}


export default {
  get, add
}
